import { act } from "react";
import { GET_LOGIN, GET_LOGIN_ERROR, GET_LOGIN_REQUEST, REMOVE_LOGED_STATUS, REMOVE_LOGIN, REMOVE_LOGIN_STATUS, UPDATE_AUTH_STATUS, UPDATE_OTP_TIME } from "../ActionTypes/ActionTypes.js";

const initialState = {

    token: null,
    authLoading: false,
    authData: null,
    authError: null,
    authStatus: null,
    isAuthenticated: false,
    userData: null,
    time: null,
    remainingTime: null,
    logged: false
};

const authReducer = (state = initialState, action) => {

    switch (action.type) {

        case GET_LOGIN_REQUEST:
            return { ...state, authLoading: true, authStatus: null, authData: null };
        case GET_LOGIN:
            return {
                authLoading: false, authData: action?.payload, authError: action?.payload?.message, authStatus: true,
                token: action.payload?.result?.accessToken,
                sid: action.payload?.result?.sid,
                isAuthenticated: action?.payload?.result?.isAuthenticated,
                userData: action?.payload?.result?.details, logged: true
            };
        case GET_LOGIN_ERROR:
            return { authLoading: false, authData: action?.payload, authError: action?.payload, authStatus: false };
        case REMOVE_LOGIN:
            return { ...state, authData: null, authError: null, authStatus: null, token: null, isAuthenticated: false, userData: null, authLoading: false, time: null, logged: false };

        case REMOVE_LOGIN_STATUS:
            return { ...state, authStatus: null, authLoading: false, time: state.time || null };
        case UPDATE_OTP_TIME:
            return { ...state, time: action.payload };
        case UPDATE_AUTH_STATUS:
            return {
                ...state, token: action.payload,
                isAuthenticated: true,
            };
        case REMOVE_LOGED_STATUS:
            return { ...state, logged: false };



        default:
            return state;
    }
};

export default authReducer;